<template>
    <transition :name="transition">
      <div tabindex="0"
           class="vld-overlay is-active"
           :class="{ 'is-full-page': isFullPage }"
           v-show="isActive"
           :aria-busy="isActive"
           aria-label="Loading"
           :style="{ zIndex }">
        <div class="vld-background"
             @click.prevent="cancel"
             :style="bgStyle">
        </div>
        <div class="vld-icon">
          <slot name="before"/>
          <slot name="default">
            <component :is="loader" :color="color" :width="width" :height="height"/>
          </slot>
          <slot name="after"/>
        </div>
      </div>
    </transition>
</template>

<script>
//import Spinner  from "@/loaders/spinner"
import {ref, watch, computed} from "vue"
import Loaders from '@/loaders/index.js';
export default {
  name: "VldComponent",
  components:
    Loaders
  ,
  props: {
    active: {
      type: Boolean,
      default: true
    },
    programmatic: Boolean,
    container: [Object, Function, HTMLElement],
    isFullPage: {
      type: Boolean,
      default: true
    },
    enforceFocus: {
      type: Boolean,
      default: true
    },
    lockScroll: {
      type: Boolean,
      default: false
    },
    transition: {
      type: String,
      default: 'fade'
    },
    /**
     * Allow user to hide the loader
     */
    canCancel: Boolean,
    /**
     * Do something on cancel
     */
    onCancel: {
      type: Function,
      default: () => {
      }
    },
    color: String,
    backgroundColor: String,
    blur: {
      type: String,
      default: '2px'
    },
    opacity: Number,
    width: Number,
    height: Number,
    zIndex: Number,
    loader: {
      type: String,
      default: 'spinner'
    }
  },
  setup(props){
    let isActive=ref(false)
    const bgStyle = {
      background: props.backgroundColor,
      opacity: props.opacity,
      backdropFilter: `blur(${props.blur})`
    }
    const cancel=()=>{
      if(!props.canCancel || !isActive.value) return
      isActive.value=false
    }
    watch(()=>props.active,(newV)=>{
      isActive.value=newV
    })
    watch(isActive,(newV)=>{

      if(newV){
        document.body.classList.add('vld-shown');
      }else{
        document.body.classList.remove('vld-shown');
      }
    })
    return{
      isActive: computed(() => isActive.value),
      bgStyle,
      cancel
    }
  },
}
</script>

<style scoped>
.vld-shown {
  overflow: hidden;
}

.vld-overlay {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  align-items: center;
  display: none;
  justify-content: center;
  overflow: hidden;
  z-index: 9999;
}

.vld-overlay.is-active {
  display: flex;
}

.vld-overlay.is-full-page {
  z-index: 9999;
  position: fixed;
}

.vld-overlay .vld-background {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  background: #fff;
  opacity: 0.5;
}

.vld-overlay .vld-icon, .vld-parent {
  position: relative;
}
</style>